module.exports = __webpack_public_path__ + "img/67.d7f6086d.svg";